export var toggleSidebar = function (state) {
    return function (dispatch) {
        dispatch({
            type: 'TOGGLE_SIDEBAR',
            payload: {
                status: state,
            },
        });
    };
};
export var toggleSubscriptionsMenu = function (state) {
    return function (dispatch) {
        dispatch({
            type: 'TOGGLE_SUBSCRIPTION_MENU',
            payload: {
                status: state,
            },
        });
    };
};
export var toggleTracksExpandMenu = function (state) {
    return function (dispatch) {
        dispatch({
            type: 'TOGGLE_TRACKS_EXPAND_MENU',
            payload: {
                status: state,
            },
        });
    };
};
export var updateScrollPosition = function (state) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_LAST_SCROLL_POSITION',
            payload: {
                status: state,
            },
        });
    };
};
export var updateSideBarOpen = function (state) {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_SIDEBAR_OPEN',
            payload: {
                status: state,
            },
        });
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/sidebar.actions.ts
// module id = 1431
// module chunks = 81